import clsx from 'clsx'

import type { PropsWithClassName } from '@fv/client-types'
import {
  type CarrierType,
  carrierFuncs,
  type GetCarrierTypeInput,
} from '@fv/models/admin'

export const getCarrierType = carrierFuncs.getCarrierType

type PropsWithCarrierType = {
  carrierType: CarrierType
}
type PropsWithCarrier = {
  carrier: GetCarrierTypeInput
}
type Props = PropsWithClassName<PropsWithCarrierType | PropsWithCarrier>

const badgeConfig: Record<
  CarrierType,
  { label: string; className: string } | null
> = {
  'api-integrated': { label: 'API', className: 'badge-primary badge-outline' },
  'global-spot': null,
  restricted: { label: 'Restricted', className: 'badge-warning badge-outline' },
  removed: { label: 'Removed', className: 'badge-error' },
}

export const CarrierBadge = ({ className, ...props }: Props) => {
  const carrierType =
    'carrierType' in props
      ? props.carrierType
      : carrierFuncs.getCarrierType(props.carrier)
  const config = badgeConfig[carrierType]
  if (!config) return null

  return (
    <span className={clsx('badge lowercase', config.className, className)}>
      {config.label}
    </span>
  )
}
